import { Avatar } from '@mantine/core'
import { ReactComponent as LegacyImageCircle } from '../../assets/imgs/user/personCircle.svg'

interface CustomProps {
  image?: string
  size?: number
}
const AppAvatar = ({ image, size = 50 }: CustomProps) => {
  return (
    <Avatar alt="Profile" size={size}>
      <LegacyImageCircle />
    </Avatar>
  )
}

export default AppAvatar
